// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__w6sCA","active":"downloadDropdown_active__1DTc2"};